import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import {
    GA4ContentClickEvent,
    GTMBaseEvent,
    GtmAnalyticsEvent,
    GtmEventType,
    GtmFilterSearchEvent,
    GtmPageLevelEvent,
    GtmSearchEvent,
} from '~/modules/analytics/gtmEventTypes/gtmEventType';

export class GtmSortClickType extends GtmEventType {
    canHandle(event: GTMBaseEvent): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_CLICK && event.elementType === 'filter' && event.gtm === 'ga4'
        );
    }

    getBody(
        event: any,
    ): GtmAnalyticsEvent | GtmPageLevelEvent | GtmSearchEvent | GtmFilterSearchEvent | GA4ContentClickEvent {
        return {
            event: 'custEv_contentClick',
            click_text: event.value,
            element_title: 'sort results',
            element_type: 'link',
        };
    }
}
